// The user-error codes the meetings feature adds. They are merged
// into `USER_ERROR_CODES` (`../events/error-codes.ts`), so the server's arch
// scan accepts them and the web catalog must carry DE/EN copy for each.
//
// Kept in its own module with no imports so `events/error-codes.ts` can pull
// it in without a cycle through the meetings barrel.

export const MEETING_USER_ERROR_CODES = [
  // A 403 on the space patch: only the organizer may set up auto-recording.
  "not_eligible",
  // The Google refresh failed (`invalid_grant`) or the organizer changed.
  "host_lost",
  // Google was disconnected while a meeting was being processed.
  "google_disconnected",
  // GitHub filing goes into private repositories only.
  "public_repo",
  // The owner's forge sign-in is missing; filing resumes after sign-in.
  "no_token",
  // A write through a link landed on an issue in another project.
  "retarget_blocked",
  // The 30-day content (transcript, topic quotes) is gone.
  "content_expired",
  // The transcript is too long for the one inventory call (no retry helps).
  "meeting_too_long",
] as const;

export type MeetingUserErrorCode = (typeof MEETING_USER_ERROR_CODES)[number];

/** Static English for each code: what a surface without a catalog prints. */
export const MEETING_USER_ERROR_FALLBACK_EN: Readonly<Record<MeetingUserErrorCode, string>> = {
  not_eligible: "Only the meeting's organizer can turn on recording.",
  host_lost: "Loom lost access to your Google account. Connect Google again.",
  google_disconnected:
    "Google was disconnected, so this meeting wasn't processed. Connect Google again.",
  public_repo: "Loom files meeting tickets only into private projects.",
  no_token: "Sign in again so Loom can file this meeting's tickets.",
  retarget_blocked: "This ticket is now in another project, so Loom didn't change it.",
  content_expired: "The meeting's transcript was deleted after 30 days, so this isn't possible any more.",
  meeting_too_long: "This meeting is too long for Loom to sort into tickets.",
};
